import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip, Typography } from 'antd'
import { find, includes, isNil, map } from 'lodash'

import { formatDateFromNow } from '../../core/utils'

import { MenuCurationTaskTableAssignation } from '../../menu-curation-tasks/components/sections'
import {
  StyledMenuAvailabiltyLabel,
  StyledMenuCurationTaskTag,
} from '../../menu-curation-tasks/components/styled'
import { MENU_CURATION_TASK_TAGS } from '../../menu-curation-tasks/constants'
import PriorityTaskAllocationActionCell from '../components/sections/priority-task-allocation-action-cell'
import PriorityTaskAllocationCheckAll from '../components/sections/priority-task-allocation-check-all'
import { computeMenuAllocationStatus } from '../helpers'

const createMenuCurationTaskTableColumns = (
  priorityTaskId,
  selectedAllocationIds,
  onSelectionChange,
  menuCurationTasks,
) => [
  {
    title: 'Brand',
    render: ({ id, menu }) => (
      <Link target="_blank" to={`/menu-curation-tasks/${id}`}>
        {menu?.brand?.name}
      </Link>
    ),
    fixed: 'left',
    width: 200,
  },

  {
    title: 'Assigned',
    width: 250,
    render: menuCurationTask => (
      <MenuCurationTaskTableAssignation
        menuCurationTask={menuCurationTask}
        isDisabled
      />
    ),
  },
  {
    title: 'Allocated user',
    width: 150,
    dataIndex: 'priorityTaskAllocations',
    render: priorityTaskAllocations => {
      const currentAllocation = find(
        priorityTaskAllocations,
        allocation => allocation.priorityTask?.id === priorityTaskId,
      )

      return currentAllocation?.allocatedUser?.name
    },
  },
  {
    title: 'Availability',
    width: 200,
    render: ({
      isAvailableForTierOne,
      isAvailableForUnknownWordsCuration,
      isAvailableForUnknownWordsQa,
      isAvailableForCuration,
      isAvailableForQa,
      isAvailableForQc,
    }) => (
      <>
        {isAvailableForTierOne && (
          <StyledMenuAvailabiltyLabel>Tier 1</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForUnknownWordsCuration && (
          <StyledMenuAvailabiltyLabel>UW Curation</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForUnknownWordsQa && (
          <StyledMenuAvailabiltyLabel>UW QA</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForCuration && (
          <StyledMenuAvailabiltyLabel>Curation</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForQa && (
          <StyledMenuAvailabiltyLabel>QA</StyledMenuAvailabiltyLabel>
        )}
        {isAvailableForQc && (
          <StyledMenuAvailabiltyLabel>QC</StyledMenuAvailabiltyLabel>
        )}
      </>
    ),
  },
  {
    title: 'Allocation status',
    width: 150,
    render: menuCurationTask =>
      computeMenuAllocationStatus(menuCurationTask, priorityTaskId),
  },
  {
    title: 'Dishes',
    width: 100,
    render: ({ menu: { dishCount } }) => dishCount,
  },
  {
    title: 'Allocated dishes',
    width: 100,
    dataIndex: 'priorityTaskAllocations',
    render: priorityTaskAllocations => {
      const currentAllocation = find(
        priorityTaskAllocations,
        allocation => allocation.priorityTask?.id === priorityTaskId,
      )

      return currentAllocation?.allocatedDishCount
    },
  },
  {
    title: 'Tags',
    width: 200,
    render: ({ tags }) =>
      map(tags, tag => (
        <StyledMenuCurationTaskTag
          key={tag}
          isError={includes(
            [
              MENU_CURATION_TASK_TAGS.HAS_TIMEOUT_ERROR.value,
              MENU_CURATION_TASK_TAGS.HAS_UNCAUGHT_AI_ERROR.value,
              MENU_CURATION_TASK_TAGS.HAS_UNCAUGHT_MENU_CURATOR_ERROR.value,
            ],
            tag,
          )}
          isWarning={includes(
            [
              MENU_CURATION_TASK_TAGS.IS_OVERDUE.value,
              MENU_CURATION_TASK_TAGS.HAS_METADATA_ERROR.value,
            ],
            tag,
          )}
        >
          {MENU_CURATION_TASK_TAGS[tag].label}
        </StyledMenuCurationTaskTag>
      )),
  },
  {
    title: 'U.W.',
    width: 100,
    render: ({
      curatedUnknownWordCount,
      qadUnknownWordCount,
      totalUnknownWordCount,
    }) => (
      <>
        <Tooltip title="Curated words">
          <Typography.Paragraph>
            {curatedUnknownWordCount} / {totalUnknownWordCount}
          </Typography.Paragraph>
        </Tooltip>
        <Tooltip title="Qad words">
          <Typography.Paragraph>
            {qadUnknownWordCount} / {totalUnknownWordCount}
          </Typography.Paragraph>
        </Tooltip>
      </>
    ),
  },
  {
    title: 'Autoeat Updated',
    width: 200,
    dataIndex: 'menu',
    render: menu => {
      const autoeatUpdateDate = !isNil(menu.autoeatUpdateAppliedAt)
        ? menu.autoeatUpdateAppliedAt
        : menu.autoeatUpdatedAt

      if (!isNil(autoeatUpdateDate)) {
        return formatDateFromNow(autoeatUpdateDate)
      }

      return null
    },
  },
  {
    title: (
      <>
        <PriorityTaskAllocationCheckAll
          menuCurationTasks={menuCurationTasks || []}
          priorityTaskId={priorityTaskId}
          selectedAllocationIds={selectedAllocationIds}
          onSelectionChange={onSelectionChange}
        />
        Actions
      </>
    ),
    width: 130,
    render: menuCurationTask => (
      <PriorityTaskAllocationActionCell
        menuCurationTask={menuCurationTask}
        priorityTaskId={priorityTaskId}
        selectedAllocationIds={selectedAllocationIds}
        onSelectionChange={onSelectionChange}
      />
    ),
  },
]

export default createMenuCurationTaskTableColumns
